import axios from '@/axios/index'

class API {
  static getActivityInfo(options) {
    return axios.post('/nice-api-customer/v1/bargainActivity/participateBargainActivity', options)
  }
  static getKanjiaList(options) {
    return axios.get(`/nice-api-customer/v1/bargainActivity/${options.bargainActivityRecordId}/recordDetail`)
  }
  static getActivityBInfo(options) {
    return axios.get(`/nice-api-customer/v1/bargainActivity/${options.bargainActivityRecordId}/record`)
  }
  static recordInfo(options) {
    return axios.get(`/nice-api-customer/v1/bargainActivity/${options.bargainActivityId}/recordInfo`)
  }
  static giftDetailInfo(options) {
    return axios.get(`/nice-api-customer/v1/bargainActivity/detailInfo`)
  }
  static newCustomerDrawAward(options) {
    return axios.post(`/nice-api-customer/v1/bargainActivity/newCustomerDrawAward`)
  }
  static beginAnswer(options) {
    return axios.post(`/nice-api-customer/v1/bargainActivity/${options.bargainActivityRecordId}/beginAnswer`)
  }
  static questions(options) {
    return axios.get(`/nice-api-customer/v1/bargainActivity/${options.bargainActivityRecordId}/question`)
  }
  static submitResult(options) {
    return axios.post(`/nice-api-customer/v1/bargainActivity/submit`,options)
  }
  static pay(options) {
    return axios.post(`/nice-api-customer/v1/bargainActivity/${options.id}/rechargeBalance`,options)
  }
}

export default API;
